import GenericRenderContainerSection from '../GenericRenderContainerSection';
import { GenericContainerCard, GenericWrapper } from './MobileUtilitiesTopMatch';
import { TopDecorColor } from '../../../specific_ppv_year_info_component/single_match_card_in_info_ppv_folder/GenericComponentCssMatchCard';
import { SpaceSideWrestlerCssComponent } from './GenericUtilitiesComponents/SpaceSideWrestlerCssComponent';
import SpaceInfoMatchComponent from './GenericUtilitiesComponents/SpaceInfoMatchComponent';
import MobileRenderWrestlerWhenOneInSide from './GenericRenderWrestlerWithLogicNumber/MobileRenderWrestlerWhenOneInSide';

function MobileDefaultTopMatchRender({ matchInfo, wrestlerId, wrestlerName, wrestlerAvatarPath }) {

    const wrestler = {
            id: wrestlerId,
            name: wrestlerName,
            avatar_path: wrestlerAvatarPath
        }

    return (
        <GenericContainerCard className='mobile-default-top-match-render'>
            <GenericWrapper className='wrapper-default-top-match'>
                <TopDecorColor 
                    className='top-decor-color' 
                    height='10px' 
                    borderTopLeftRadius='10px' 
                    borderTopRightRadius='10px' 
                />
                {/* Wrestler Attivo */}
                <SpaceSideWrestlerCssComponent className='space-side-wrestler left'>
                    <MobileRenderWrestlerWhenOneInSide
                        wrestler={wrestler} 
                        side='left'
                        key="0000"
                    />
                </SpaceSideWrestlerCssComponent>

                {/* Centro  */}
                <SpaceInfoMatchComponent matchInfo={matchInfo} />


            </GenericWrapper>
            
        </GenericContainerCard>
    )
}

export default MobileDefaultTopMatchRender;